import "./style.scss";

const ButtonComponent = ({ ...props }) => (
    <button
        className={`button-component ${props.moreClass}`}
        style={{
            color: `${props.colorTitle}`,
            backgroundColor: `${props.colorBackground}`,
            border: `${props.isBorder && "2px solid"}`,
        }}
        {...props}
    >
        {props.btnLoginTitle && (
            <span style={{ paddingLeft: `${props.icon && "20px"}` }}>
                {props.icon && <img src={props.icon} alt="" srcSet="" />}
                {props.svgIcon && (
                    <svg fill={`${props.colorTitle}`}>
                        <use xlinkHref={props.svgIcon} />
                    </svg>
                )}
                <span className="login-title">{props.btnLoginTitle ? props.btnLoginTitle : "User"}</span>
            </span>
        )}
        {props.btnTitle && (
            <span
                style={{
                    paddingLeft: `${props.icon && "5px"}`,
                }}
            >
                {props.link ? (
                    <a
                        href={`/${props.link}`}
                        style={{
                            color: `${props.colorTitle}`,
                        }}
                    >
                        <span>{props.btnTitle ? props.btnTitle : "User"}</span>
                    </a>
                ) : (
                    <a>
                        {props.icon && <img src={props.icon} alt="" srcSet="" />}
                        {props.svgIcon && (
                            <svg>
                                <use xlinkHref={props.svgIcon} />
                            </svg>
                        )}
                        <span>{props.btnTitle ? props.btnTitle : "User"}</span>
                    </a>
                )}
            </span>
        )}
    </button>
);

export default ButtonComponent;
